module.exports = __webpack_public_path__ + "img/sweden-male.fdf04d60.png";